import {
  analyticsRepo,
  type AnalyticsLeaderboardEntry,
  type AnalyticsRange,
  type AnalyticsSnapshot,
} from './analytics.repo'

export const analyticsService = {
  async getSnapshot(range: AnalyticsRange): Promise<AnalyticsSnapshot> {
    return analyticsRepo.getSnapshot(range)
  },
  async getLeaderboard(): Promise<AnalyticsLeaderboardEntry[]> {
    return analyticsRepo.getLeaderboard()
  },
}

export type {
  AnalyticsRange,
  AnalyticsSnapshot,
  AnalyticsStats,
  AnalyticsInsightPoint,
  AnalyticsTopUser,
  AnalyticsNamedValue,
  AnalyticsEngagement,
  AnalyticsLocationRow,
  AnalyticsLeaderboardEntry,
} from './analytics.repo'
